import { useState, useEffect } from 'react';
import { selectAuthors } from '../store/authors';
import { selectCategories } from '../store/categories';
import { useAppSelector } from '../store/hooks';
import { Category } from '../types/types';

export default function usePredictiveSearch(search: string) {
  const [matchingCategories, setMatchingCategories] = useState<Category[]>([]);
  const [matchingAuthors, setMatchingAuthors] = useState<string[]>([]);
  const authors = useAppSelector(selectAuthors);
  const categories = useAppSelector(selectCategories);

  useEffect(() => {
    setMatchingAuthors(
      authors.filter((author) =>
        author.toLowerCase().includes(search.toLowerCase()),
      ),
    );
    setMatchingCategories(
      categories.filter((category) =>
        category.name.toLowerCase().includes(search.toLowerCase()),
      ),
    );
  }, [search, categories, authors]);

  return { matchingAuthors, matchingCategories };
}
